<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">
                  Ordem de Serviço nº {{ viewModel.number }} —
                  {{ viewModel.title }}
                </strong>
                <span
                  class="badge align-self-center ml-auto"
                  :class="'badge-' + Variante(viewModel.status)"
                >
                  {{ viewModel.statusName }}
                </span>
              </div>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-3">
                  <label for>Equipe</label>
                  <p>{{ viewModel.teamName || "-" }}</p>
                </div>
                <div class="col-sm-12 col-md-3">
                  <label for>Data prevista</label>
                  <p>{{ FormatarData(viewModel.scheduledDate) }}</p>
                </div>
                <div class="col-sm-12 col-md-3">
                  <label for>Início</label>
                  <p>{{ FormatarData(viewModel.startDate) }}</p>
                </div>
                <div class="col-sm-12 col-md-3">
                  <label for>Conclusão</label>
                  <p>{{ FormatarData(viewModel.endDate) }}</p>
                </div>
              </div>
              <div class="row" v-if="viewModel.description">
                <div class="col-sm-12">
                  <label for>Descrição</label>
                  <p>{{ viewModel.description }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <label for>Andamento</label>
                  <p>
                    {{ Executados }} de {{ viewModel.items.length }} árvores
                    apontadas · {{ Pendentes }} pendentes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">Árvores</strong>
            </header>
            <div class="card-body">
              <b-table
                :hover="true"
                responsive
                striped
                :items="viewModel.items"
                :fields="fields"
                show-empty
                empty-text="Nenhuma árvore nesta ordem de serviço."
              >
                <template v-slot:empty="scope">
                  <h6 class="mt-2">{{ scope.emptyText }}</h6>
                </template>
                <template v-slot:cell(commonName)="data">
                  {{ data.item.commonName }}
                  <span
                    v-if="data.item.treeRemoved"
                    class="badge badge-danger ml-1"
                    title="Essa árvore foi excluída do cadastro depois da criação da OS."
                  >
                    Árvore excluída
                  </span>
                </template>
                <template v-slot:cell(managers)="data">
                  {{ (data.item.managers || []).join(", ") }}
                </template>
                <template v-slot:cell(statusName)="data">
                  <span
                    class="badge"
                    :class="'badge-' + VarianteItem(data.item.status)"
                  >
                    {{ data.item.statusName }}
                  </span>
                </template>
                <template v-slot:cell(executionDate)="data">
                  {{ FormatarData(data.item.executionDate) }}
                </template>
                <template v-slot:cell(acoes)="data">
                  <b-button
                    variant="info"
                    size="sm"
                    title="Apontar execução"
                    :disabled="OrdemFinalizada"
                    @click="AbrirApontamento(data.item)"
                  >
                    <i class="fas fa-clipboard-check"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="btn-toolbar mb-3 ml-3" role="toolbar">
              <div
                class="btn-group mr-2"
                role="group"
                v-for="transicao in Transicoes"
                :key="transicao.id"
              >
                <button
                  class="btn"
                  :class="'btn-' + transicao.variant"
                  type="button"
                  :disabled="TransicaoBloqueada(transicao)"
                  :title="
                    TransicaoBloqueada(transicao)
                      ? 'Existem árvores pendentes de apontamento.'
                      : ''
                  "
                  @click="AlterarStatus(transicao)"
                >
                  {{ RotuloTransicao(transicao) }}
                </button>
              </div>
              <div class="btn-group" role="group">
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="$router.push('/ordem-servico')"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        v-model="modalApontamento"
        size="lg"
        title="Apontamento de execução"
        ok-title="Salvar"
        cancel-title="Fechar"
        @ok="SalvarApontamento"
        @hidden="FecharApontamento"
      >
        <div v-if="itemSelecionado">
          <p class="mb-3">
            <strong>{{ itemSelecionado.commonName }}</strong>
            — sequência {{ itemSelecionado.sequence }} ·
            {{ itemSelecionado.location }}
          </p>
          <div class="form-group">
            <label for>* Situação</label>
            <b-form-radio-group
              v-model="apontamento.status"
              :options="opcoesApontamento"
            ></b-form-radio-group>
          </div>
          <div class="form-group">
            <label for>
              {{ ObservacaoObrigatoria ? "* Observação" : "Observação" }}
            </label>
            <textarea
              v-model="apontamento.executionNote"
              class="form-control"
              rows="3"
              placeholder="Descreva o que foi executado ou o motivo da não execução"
            ></textarea>
          </div>

          <hr />

          <div class="form-group">
            <label for>Fotos</label>
            <b-form-file
              v-model="arquivos"
              multiple
              placeholder="Escolha a(s) foto(s)..."
              drop-placeholder="Solte os arquivos aqui..."
              browse-text="Procurar"
            ></b-form-file>
            <button
              class="btn btn-primary mt-2"
              type="button"
              :disabled="!arquivos || arquivos.length === 0 || enviandoFotos"
              @click="EnviarFotos"
            >
              {{ enviandoFotos ? "Enviando..." : "Enviar fotos" }}
            </button>
          </div>

          <GalleryImage
            v-if="fotos.length > 0"
            :images="fotos"
            remove-emit="remove-file"
            @remove-file="RemoverFoto"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import GalleryImage from "../../components/GalleryImage";
import WorkOrderService from "../../servico/WorkOrderService";
import ArquivoServico from "../../servico/ArquivoServico";
import WorkOrderStatus from "../../enums/WorkOrderStatusEnum";
import WorkOrderItemStatus from "../../enums/WorkOrderItemStatusEnum";
import DateTime from "../../util/DateTime";
import ApiError from "../../util/ApiError";

export default {
  name: "WorkOrderExecution",
  components: {
    RotateSquare,
    GalleryImage
  },
  data() {
    return {
      loading: false,
      enviandoFotos: false,
      modalApontamento: false,
      itemSelecionado: null,
      arquivos: null,
      fotos: [],
      apontamento: {
        id: null,
        status: WorkOrderItemStatus.Enum.Executed,
        executionNote: ""
      },
      opcoesApontamento: [
        { text: "Executada", value: WorkOrderItemStatus.Enum.Executed },
        { text: "Não executada", value: WorkOrderItemStatus.Enum.NotExecuted }
      ],
      viewModel: {
        id: null,
        number: null,
        title: "",
        description: "",
        status: null,
        statusName: "",
        teamName: "",
        scheduledDate: null,
        startDate: null,
        endDate: null,
        items: []
      },
      fields: [
        { key: "order", label: "Ordem", sortable: true },
        { key: "sequence", label: "Seq.", sortable: true },
        { key: "commonName", label: "Espécie", sortable: true },
        { key: "location", label: "Local", sortable: false },
        { key: "managers", label: "Manejos", sortable: false },
        { key: "statusName", label: "Situação", sortable: true },
        { key: "executedByNome", label: "Executado por", sortable: true },
        { key: "executionDate", label: "Data", sortable: true },
        { key: "filesCount", label: "Fotos", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  computed: {
    Pendentes() {
      return this.viewModel.items.filter(
        (x) => x.status === WorkOrderItemStatus.Enum.Pending
      ).length;
    },
    Executados() {
      return this.viewModel.items.length - this.Pendentes;
    },
    OrdemFinalizada() {
      return WorkOrderStatus.IsFinal(this.viewModel.status);
    },
    Transicoes() {
      return WorkOrderStatus.AllowedTransitions(this.viewModel.status);
    },
    ObservacaoObrigatoria() {
      return this.apontamento.status === WorkOrderItemStatus.Enum.NotExecuted;
    }
  },
  created() {
    let id = this.$route.params.id;
    if (id) this.Obter(id);
  },
  methods: {
    FormatarData(data) {
      return DateTime.FormatLocale(data) || "-";
    },
    Variante(status) {
      return WorkOrderStatus.Variant(status);
    },
    VarianteItem(status) {
      return WorkOrderItemStatus.Variant(status);
    },
    RotuloTransicao(transicao) {
      if (transicao.id === WorkOrderStatus.Enum.InProgress)
        return "Iniciar execução";
      if (transicao.id === WorkOrderStatus.Enum.Completed)
        return "Concluir ordem";
      return "Cancelar ordem";
    },
    TransicaoBloqueada(transicao) {
      return (
        transicao.id === WorkOrderStatus.Enum.Completed && this.Pendentes > 0
      );
    },
    AlterarStatus(transicao) {
      WorkOrderService.ChangeStatus(this.viewModel.id, transicao.id)
        .then(() => {
          this.$notify({
            data: ["Situação alterada com sucesso."],
            type: "success",
            duration: 5000
          });
          this.Obter(this.viewModel.id);
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    AbrirApontamento(item) {
      this.itemSelecionado = item;
      this.apontamento = {
        id: item.id,
        status:
          item.status && item.status !== WorkOrderItemStatus.Enum.Pending
            ? item.status
            : WorkOrderItemStatus.Enum.Executed,
        executionNote: item.executionNote || ""
      };
      this.arquivos = null;
      this.fotos = [];
      this.modalApontamento = true;
      this.ObterFotos(item.id);
    },
    FecharApontamento() {
      this.itemSelecionado = null;
      this.arquivos = null;
      this.fotos = [];
    },
    ObterFotos(workOrderItemId) {
      WorkOrderService.GetItemFiles(workOrderItemId)
        .then((resposta) => {
          this.fotos = resposta.data || [];
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    EnviarFotos() {
      if (!this.arquivos || this.arquivos.length === 0) return;
      if (!this.itemSelecionado) return;

      this.enviandoFotos = true;
      let workOrderItemId = this.itemSelecionado.id;

      ArquivoServico.New(this.arquivos)
        .then((resposta) => {
          return WorkOrderService.AddItemFiles(workOrderItemId, resposta.data);
        })
        .then(() => {
          this.enviandoFotos = false;
          this.arquivos = null;
          this.ObterFotos(workOrderItemId);
          this.$notify({
            data: ["Fotos enviadas com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.enviandoFotos = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    RemoverFoto(foto) {
      if (!this.itemSelecionado) return;

      let workOrderItemId = this.itemSelecionado.id;

      WorkOrderService.RemoveItemFile(foto.id, workOrderItemId)
        .then(() => {
          this.ObterFotos(workOrderItemId);
          this.$notify({
            data: ["Foto removida com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    SalvarApontamento(evento) {
      evento.preventDefault();

      if (
        this.ObservacaoObrigatoria &&
        (!this.apontamento.executionNote ||
          this.apontamento.executionNote.trim().length === 0)
      ) {
        this.$notify({
          data: ["Informe o motivo da não execução."],
          type: "warn",
          duration: 5000
        });
        return;
      }

      WorkOrderService.ExecuteItem({
        id: this.apontamento.id,
        status: this.apontamento.status,
        executionNote: this.apontamento.executionNote
      })
        .then(() => {
          this.modalApontamento = false;
          this.$notify({
            data: ["Apontamento salvo com sucesso."],
            type: "success",
            duration: 5000
          });
          this.Obter(this.viewModel.id);
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Obter(id) {
      this.loading = true;

      WorkOrderService.Get(id)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
          if (!this.viewModel.items) this.viewModel.items = [];
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
